import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlayerClass } from '../player';

@Component({
  selector: 'app-playwinner',
  templateUrl: './playwinner.component.html',
  styleUrls: ['./playwinner.component.css']
})
export class PlaywinnerComponent implements OnInit {

  constructor( private route : ActivatedRoute) { }
 public winner : PlayerClass;

 ngOnInit(){
﻿
this.winner = JSON.parse(this.route.snapshot.paramMap.get('player'));
// Remove Local storage
    localStorage.removeItem('players');
}

}



// WEBPACK FOOTER //
// C:/Users/BHAJ/Desktop/dribbler/src/app/playwinner/playwinner.component.ts